import { Directive, ElementRef, HostListener } from '@angular/core';
import { RegExValidation } from '../constants/regex-validation.constants';

@Directive({
  selector: '[name-field]'
})
export class NameFieldDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initalValue = this.el.nativeElement.value;

    this.el.nativeElement.value = initalValue.replace(RegExValidation.text, '');
    // console.log('(1) ' + this.el.nativeElement.value);
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
